const themeFonts = {
    fonts: {
        heading: "'Quarto', serif",
        body: "'GTEesti', sans-serif",
    },
}

export default themeFonts
